import React from 'react';
const { Fragment, useEffect, useState } = React;
import ReactDOM from 'react-dom';

import styles from './styles.scss';
import classnames from 'classnames';

const Sidebar: React.FunctionComponent<{
  visible: boolean;
  width?: string | number;
  onEscape?: () => void;
  onBlur?: () => void;
}> = ({ visible, width, onBlur, onEscape, children }) => {
  // This is a hack that needs to be here in order to properly let the sidebar
  // open and close without the animation behavior acting weirdly.
  const [openSidebar, setOpenSidebar] = useState(true);
  const [renderSidebar, setRenderSidebar] = useState(false);
  useEffect(() => {
    let unmounted = false;
    if (visible) {
      setRenderSidebar(true);
      setOpenSidebar(true);
    } else {
      setOpenSidebar(false);
      setTimeout(() => {
        if (!unmounted) {
          setRenderSidebar(false);
        }
      }, 500);
    }

    return () => {
      unmounted = true;
    };
  }, [visible]);

  if (!renderSidebar) { return null; }

  return ReactDOM.createPortal(
    <div
      className={classnames(styles.backdrop, { [styles.visible]: openSidebar })}
      onMouseDown={() => onBlur()}
      onKeyDown={e => e.keyCode === 27 && onEscape && onEscape()}
    >
      <div
        className={styles.sidebar}
        style={{ width }}
        onMouseDown={e => e.stopPropagation()}
      >
        {children}
      </div>
    </div>,
    document.body
  );
};

export default Sidebar;
